import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from 'e4shared';

export const YourBlogsModal = ({ data, st }) => {
    if (!data) return <Loading />;
    const posts = data.reduce((a, d) => (a.some(y => y.id === d.id) ? a : a.concat(d)), []);
    return (
        <div>
            {posts.map(post => {
                const likes = data.filter(d => (d.type = 'like' && d.id === post.id)).length;
                const comments = data.filter(d => (d.type = 'comment' && d.id === post.id)).length;
                return (
                    <div key={`profile-${post.profile_Id}`} className="flex flex-top mb10">
                        <div className="flex-grow">
                            <div className="mb5">
                                <span className="mr10 text-lg">
                                    <Link to={`/blog/post/${post.id}`}>{post.title}</Link>
                                </span>
                            </div>
                            <div key={`task-${post.id}`} className="flex flex-top mb5">
                                <div className="flex-grow">
                                    {comments > 0 && (
                                        <div>
                                            <i className="fa fa-comment mr10" />
                                            {`${comments} ${st('Comments')}`}
                                        </div>
                                    )}
                                    {likes > 0 && (
                                        <div>
                                            <i className="fa fa-thumbs-up mr10" />
                                            {`${likes} ${st('Likes')}`}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(YourBlogsModal);
